import React, { Component } from 'react';
import { Form, Input, DatePicker } from 'antd';
import { FormLayout } from '@/components';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import moment from 'moment';
import { CHECK_name, CHECK_phone } from '@/shared/reqexp';
const { RangePicker } = DatePicker;
const mapStateToProps = (rootState) => ({
    _state: rootState.cashTop,
});
class TopForm extends Component {
    constructor() {
        super(...arguments);
        this.getRangeItem = () => {
            const { status } = this.props._state;
            let label;
            let filed;
            switch (status) {
                case '0':
                    label = '申请时间';
                    filed = 'time';
                    break;
                case '2':
                    label = '驳回时间';
                    filed = 'time';
                    break;
                case '1':
                    label = '通过时间';
                    filed = 'time';
                    break;
                default:
                    console.warn('提现状态错误');
            }
            return { label, filed };
        };
        this.onChange = (data) => {
            dispatch.cashTop.onChange(data);
        };
    }
    componentDidMount() {
        dispatch.cashTop.SET_STATE({ form: this.props.form });
    }
    dealDate(currentDate) {
        const now = moment();
        return currentDate > now;
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { label, filed } = this.getRangeItem();
        return (<FormLayout form={this.props.form} onSearch={this.onChange}>
          <Form.Item label="经销商名称">
              {getFieldDecorator('distributorName', {
            rules: [{
                    validator: CHECK_name(20),
                }],
        })(<Input placeholder="请输入经销商名称"/>)}
          </Form.Item>
          <Form.Item label="经销商联系电话">
              {getFieldDecorator('distributorPhone', {
            rules: [{
                    pattern: CHECK_phone,
                    message: '请输入正确格式的手机号',
                }],
        })(<Input placeholder="请输入经销商联系电话"/>)}
          </Form.Item>
          <Form.Item label={label}>
              {getFieldDecorator(filed, {})(<RangePicker className="width-100" disabledDate={this.dealDate} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
          </Form.Item>
      </FormLayout>);
    }
}
const Top = Form.create({})(TopForm);
export default connect(mapStateToProps)(Top);
